var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M446,66v380H66V66H446"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "66,66 256,256 66,446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "446,66 256,256 446,446  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M292.417,231.331c23.993,42.01-19.076,85.078-61.086,61.086c-4.888-2.792-8.957-6.861-11.748-11.748  c-23.993-42.01,19.076-85.078,61.086-61.086C285.556,222.375,289.625,226.444,292.417,231.331z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M258.737,224.266l6.774,20.31l21.409,0.166c2.772,0.021,3.921,3.559,1.691,5.205l-17.223,12.718   l6.458,20.413c0.836,2.643-2.173,4.829-4.428,3.217L256,273.846l-17.418,12.45c-2.255,1.612-5.264-0.574-4.428-3.217l6.458-20.413   l-17.223-12.718c-2.23-1.647-1.08-5.184,1.691-5.205l21.409-0.166l6.774-20.31C254.14,221.637,257.86,221.637,258.737,224.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.318,16.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55L256,40.738l-8.39,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C255.104,15.588,256.896,15.588,257.318,16.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M373.456,16.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55l-8.39-5.997l-8.391,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C371.242,15.588,373.034,15.588,373.456,16.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M141.18,16.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55l-8.39-5.997l-8.391,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C138.966,15.588,140.758,15.588,141.18,16.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.318,461.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55l-8.39-5.998l-8.39,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C255.104,460.588,256.896,460.588,257.318,461.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M373.456,461.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55l-8.39-5.997l-8.391,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C371.242,460.588,373.034,460.588,373.456,461.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M141.18,461.854l3.263,9.784l10.313,0.08c1.335,0.01,1.889,1.714,0.815,2.508l-8.297,6.127   l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.55l-8.39-5.997l-8.391,5.997c-1.086,0.776-2.536-0.277-2.133-1.55l3.111-9.833   l-8.297-6.127c-1.074-0.793-0.52-2.497,0.815-2.508l10.313-0.08l3.263-9.784C138.966,460.588,140.758,460.588,141.18,461.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M131.965,233.931h-28.034v28.034c0,15.483,12.552,28.034,28.034,28.034S160,277.448,160,261.966   C160,246.482,147.448,233.931,131.965,233.931z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "160,290 144.59,287.012 131.965,261.966 157.012,274.59 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/GD.c54df66b353d46d0ebd2662658d765f1.svg";
export { ForwardRef as ReactComponent };